import { useMemo, useState } from 'react'
import { getEmpresas } from '../../../../../services/localstorage/localstorage.service'
import { formatarDataHoraPayload, parseDataHora } from '../../shared/respostas.util'

export const LIMITES = { responsavelNome: 255, observacao: 2000 }

const pad = valor => `${valor}`.padStart(2, '0')

function formularioVazio() {
  return {
    checklist: null,
    company: null,
    responsavelUser: null,
    semUsuario: false,
    responsavelNome: '',
    comDeadline: false,
    deadlineData: null,
    deadlineHora: '',
    observacao: '',
  }
}

// Na edição, formulário/empresa/responsável do registro entram mesmo que não estejam mais nas listas
function formularioDe(preenchimento, formInit, empresas) {
  if (!preenchimento) return formularioVazio()

  const deadline = parseDataHora(preenchimento.deadline)
  const checklist = formInit.checklists.find(c => c.id === preenchimento.checklist_id) || {
    id: preenchimento.checklist_id,
    checklist_code: preenchimento.checklist_code,
    title: preenchimento.title,
  }
  const company = preenchimento.company_id
    ? empresas.find(c => c.id === preenchimento.company_id) || {
        id: preenchimento.company_id,
        name: preenchimento.company_name,
      }
    : null
  const responsavelUser = preenchimento.responsavel_user_id
    ? formInit.users.find(u => u.id === preenchimento.responsavel_user_id) || {
        id: preenchimento.responsavel_user_id,
        name: preenchimento.responsavel_user_name,
      }
    : null

  return {
    checklist,
    company,
    responsavelUser,
    semUsuario: !responsavelUser,
    responsavelNome: preenchimento.responsavel_nome || '',
    comDeadline: !!deadline,
    deadlineData: deadline,
    deadlineHora: deadline ? `${pad(deadline.getHours())}:${pad(deadline.getMinutes())}` : '',
    observacao: preenchimento.observacao || '',
  }
}

export function incluirOpcao(opcoes, opcao) {
  if (!opcao || opcoes.some(o => o.id === opcao.id)) return opcoes
  return [opcao, ...opcoes]
}

export function validar(form, preenchimento) {
  if (!form.checklist) return 'Selecione o formulário'

  if (form.semUsuario) {
    if (!form.responsavelNome.trim()) return 'Informe o nome do responsável pelo preenchimento'
  } else if (!form.responsavelUser) {
    return 'Selecione o responsável pelo preenchimento'
  }

  if (form.comDeadline) {
    const deadline = formatarDataHoraPayload(form.deadlineData, form.deadlineHora)
    if (!deadline) return 'Informe a data e a hora do deadline'

    const limite = preenchimento ? parseDataHora(preenchimento.created_at) : new Date()
    const referencia = new Date(
      limite.getFullYear(),
      limite.getMonth(),
      limite.getDate(),
      limite.getHours(),
      limite.getMinutes(),
    )
    if (parseDataHora(deadline) < referencia) {
      return preenchimento
        ? 'O deadline não pode ser anterior à criação do preenchimento'
        : 'O deadline não pode ser anterior à data e hora atuais'
    }
  }

  if (form.observacao.length > LIMITES.observacao) {
    return `A observação deve ter no máximo ${LIMITES.observacao} caracteres`
  }

  return null
}

export function montarPayload(form, preenchimento) {
  return {
    id: preenchimento ? preenchimento.id : undefined,
    checklist_id: form.checklist.id,
    company_id: form.company ? form.company.id : null,
    responsavel_user_id: form.semUsuario ? null : form.responsavelUser.id,
    responsavel_nome: form.semUsuario ? form.responsavelNome.trim() : null,
    deadline: form.comDeadline
      ? formatarDataHoraPayload(form.deadlineData, form.deadlineHora)
      : null,
    observacao: form.observacao.trim() || null,
  }
}

const INITIAL_STATE = {
  form: formularioVazio(),
  empresas: [],
}

export default function useModalPreenchimento() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      start(preenchimento, formInit) {
        const empresas = getEmpresas()
        setState({ form: formularioDe(preenchimento, formInit, empresas), empresas })
      },
      onChange(chave, valor) {
        setState(prev => ({ ...prev, form: { ...prev.form, [chave]: valor } }))
      },
    }
  }, [])

  return { state, localDispatch }
}
